import { AuthorRoles, IChatMessage } from '../../../libs/models/ChatMessage';

/**
 * The bot message whose inline CSAT widget should render, if any. A LiveChat-resolution widget skips the
 * customer's EnableInChatCsat: the agent's resolve already decided under the server flags, and re-checking
 * here in the customer's rollout bucket would silently drop it whenever the two buckets disagree (#2638).
 * So turning the server flags off stops new resolution prompts but, unlike a sentiment widget, leaves one
 * already offered in place until the customer answers or dismisses it — accepted, see LiveChatResolutionCsatEnabled.
 */
export const inlineCsatMessage = (
    messages: IChatMessage[],
    enableInChatCsat: boolean | undefined,
): IChatMessage | undefined => {
    const flagged = messages.find((m) => m.authorRole === AuthorRoles.Bot && !!m.showCsatWidget && !!m.id);
    return enableInChatCsat || flagged?.csatTrigger === 'Resolution' ? flagged : undefined;
};
